window.theme = window.theme || {};

theme.initWhenVisible = function(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };
    if(this.querySelector('.remove_desk_scroll')) {
      if(window.innerWidth < 767) {
        this.promotion = this.querySelector('.promotion');
      }
    } else {
      this.promotion = this.querySelector('.promotion');
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion?.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion?.cloneNode(true);
        if (this.clone) {
          this.clone.setAttribute('aria-hidden', true);
          this.appendChild(this.clone);

          const imageWrapper = this.clone.querySelector('.media-wrapper');
          if (imageWrapper) {
            imageWrapper.classList.remove('loading');
          }
        }
      }

      const animationTimeFrame = (this.promotion?.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);